/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_Name_CreateInputs */

const en_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const ar_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء`)
};

const de_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const es_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const fr_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer`)
};

const it_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea`)
};

const ja_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`創作`)
};

const ko_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이티브`)
};

const pt_br_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

const ru_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Креатив`)
};

const th_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้าง`)
};

const tr_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaratıcılık`)
};

const zh_cn_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作`)
};

const zh_tw_daily_paywall_allow_list_name_create = /** @type {(inputs: Daily_Paywall_Allow_List_Name_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`創作`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Daily_Paywall_Allow_List_Name_CreateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_name_create = /** @type {((inputs?: Daily_Paywall_Allow_List_Name_CreateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_Name_CreateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_name_create(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_name_create(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_name_create(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_name_create(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_name_create(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_name_create(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_name_create(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_name_create(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_name_create(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_name_create(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_name_create(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_name_create(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_name_create(inputs)
	return zh_tw_daily_paywall_allow_list_name_create(inputs)
});